import { tipList } from '@/mocks/homeContent';
import SectionHead from './SectionHead';

const levelMeta = {
  high: { label: '高避雷', cls: 'text-primary-700 bg-primary-100', icon: 'ri-shield-cross-line' },
  mid: { label: '中避雷', cls: 'text-accent-800 bg-accent-100', icon: 'ri-shield-check-line' },
  low: { label: '多留意', cls: 'text-secondary-900 bg-secondary-200', icon: 'ri-eye-close-line' },
};

export default function Tips() {
  return (
    <section id="tips" className="scroll-mt-24 bg-accent-50/50 py-12 md:py-16">
      <div className="container-x">
        <div className="mb-8 flex flex-col items-start gap-3 md:mb-10">
          <span className="section-eyebrow">
            <i className="ri-shield-cross-line text-sm" aria-hidden="true"></i>
            帮你不踩坑
          </span>
          <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">搭讪博主避雷清单</h2>
          <p className="max-w-2xl text-sm leading-7 text-foreground-600 md:text-base">
            选号入坑前，先对照这份编辑部沉淀的避雷清单——排在前面的坑最容易让人花冤枉时间。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {tipList.map((tip, idx) => {
            const meta = levelMeta[tip.level];
            return (
              <div
                key={tip.title}
                className="flex h-full flex-col gap-3 rounded-2xl border border-background-200 bg-background-50 p-5 shadow-soft"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-background-100 text-foreground-700">
                    <span className="flex h-9 w-9 items-center justify-center text-lg font-bold">{String(idx + 1).padStart(2, '0')}</span>
                  </span>
                  <span className={`chip px-2 py-0.5 text-xs font-bold ${meta.cls}`}>
                    <i className={`${meta.icon} text-sm`} aria-hidden="true"></i>
                    {meta.label}
                  </span>
                </div>
                <h3 className="font-heading text-base font-bold leading-6 text-foreground-950">{tip.title}</h3>
                <p className="text-sm leading-6 text-foreground-600">{tip.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}